import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import styled from 'styled-components'

const DesktopNav = styled.nav`
  grid-column: 2 / 3;
  display: flex;
  flex-wrap: wrap;
  margin: -10px 0px;
  justify-content: center;
  align-items: center;
  a {
    text-decoration: none;
    padding: 0 20px;
    color: white;
    font-size: 16px;
    margin: 10px 0px;
    white-space: nowrap;
  }
  a:hover {
    color: #B8C4C2;
  }
`

const RealmLogo = styled.img`
  grid-column: 1 / 2;
`

const RealmLogoSmall = styled.img`
  height: 25px;
`

const DesktopNavWrapper = styled.div`
  align-items: center;
  user-select: none;
  display: grid;
  grid-template-columns: 126px auto 126px;
  grid-column-gap: 120px;
  margin-bottom: 65px;
  @media (max-width: 909px) {
    display: none;
  }
  .dropdown {
    position: relative;
    cursor: default;
    margin: 10px 0;
    padding: 0 20px;
    p {
      color: white;
      font-size: 16px;
    }
  }
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    border: 1px solid #B8C4C2;
    border-radius: 5px;
    padding: 0 15px;
    z-index: 1;
    a {
      padding: 15px 15px 0;
      color: #5D6C74;
    }
    a:last-child {
      padding-bottom: 15px;
    }
    a:hover {
      color: #7d898f;
    }
  }
  .dropdown:hover .dropdown-content {
    display: flex;
    flex-direction: column;
  }
`

const MobileNavWrapper = styled.nav`
  -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
  display: flex;
  width: 100%;
  flex-direction: column;
  background: linear-gradient(96.64deg, #061621 0%, #21373C 99.64%);
  padding: 0px 0px;
  @media (min-width: 910px) {
    display: none;
  }
  cursor: pointer;
  position: absolute;
  user-select: none;
`

const Hamburger = styled.img`
  height: 17px
`

const MenuBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 20px;
  margin: 0px 0px;
  user-select: none;
`
const MenuItems = styled.div`
  user-select: none;
  -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
  color: white;
  h2, a {
    margin: 15px 0px;
    margin-left: 20px;
    font-size: 24px;
    line-height: 32px;
    color: white;
    font-weight: bold;
  }
  a:hover {
    color: #B8C4C2;
  }
  flex-direction: column;
  display: ${props => props.isOpen ? 'flex' : 'none'};
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(96.64deg, #061621 0%, #21373C 99.64%);
`

const StyledMobileDropdown = styled.div`
  user-select: none;
  a {
    font-weight: normal;
    padding-left: 15px;
  }
  .chevron{
    margin: 0px 10px;
    transform: ${(props) => props.open ? 'rotate(180deg)' : 'none'};
  }
`

const navLinks = [
  {
    type: 'link',
    text: 'Release Notes',
    url: '/release-notes'
  }, {
    type: 'link',
    text: 'GitHub',
    url: 'https://github.com/realm'
  }, {
    type: 'dropdown',
    text: 'Docs',
    links: [
      {
        type: 'link',
        text: '10.0 and later',
        url: 'https://docs.mongodb.com/realm/sdk'
      },
      {
        type: 'link',
        text: 'Previous Versions',
        url: 'https://docs.mongodb.com/realm-legacy/docs/'
      }
    ]
  }, {
    type: 'link',
    text: 'Blog',
    url: 'https://developer.mongodb.com/learn/?content=Articles&products=Mobile#main'
  }, {
    type: 'link',
    text: 'Community',
    url: '/community'
  }, {
    type: 'link',
    text: 'Realm Sync',
    url: 'https://www.mongodb.com/realm/mobile/sync'
  }, {
    type: 'link',
    text: 'Install',
    url: 'https://docs.mongodb.com/realm/sdk'
  }
]

const LinkWrapper = ({ href, text }) => {
  if (href.startsWith('http')) {
    return (
      <a href={href} target='_blank' rel='noopener noreferrer'>
        {text}
      </a>
    )
  } else {
    return <Link to={href}>{text}</Link>
  }
}

const DesktopDropDown = ({ text, links }) => {
  return (
    <div className='dropdown'>
      <p>{text}</p>
      <div className='dropdown-content'>
        {links.map((link, i) => {
          return <LinkWrapper href={link.url} text={link.text} key={i} />
        })}
      </div>
    </div>
  )
}

const MobileDropdown = ({ text, links }) => {
  const [open, setOpen] = useState(false)
  return (
    <StyledMobileDropdown open={open}>
      <h2
        onClick={() => { setOpen(!open) }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignContent: 'center'
        }}
      >
        {text}
        <img className='chevron' alt='chevron' src='https://webassets.mongodb.com/_com_assets/cms/arrow-fpm24fj24b.svg' />
      </h2>
      <div
        className='mobile-dropdown-content'
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {open && links.map((link, i) => {
          return <LinkWrapper href={link.url} text={link.text} key={i} />
        })}
      </div>
    </StyledMobileDropdown>
  )
}

const Nav = ({ siteTitle }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  return (
    <>
      <DesktopNavWrapper>
        <Link to='/'><RealmLogo src='https://webassets.mongodb.com/_com_assets/cms/realm_logo-7o6az6770h.svg' /></Link>
        <DesktopNav>
          {navLinks.map((link, i) => {
            if (link.type === 'link') {
              return <LinkWrapper href={link.url} text={link.text} key={i} />
            } else {
              return (
                <DesktopDropDown text={link.text} links={link.links} key={i} />
              )
            }
          })}
        </DesktopNav>
      </DesktopNavWrapper>
      <MobileNavWrapper>
        <MenuBar onClick={() => { setMobileNavOpen(!mobileNavOpen) }}>
          <Link to='/'><RealmLogoSmall src='https://webassets.mongodb.com/_com_assets/cms/realm_logo-7o6az6770h.svg' /></Link>
          <Hamburger src='https://webassets.mongodb.com/_com_assets/cms/hamburger-2h07jf1qdc.png' />
        </MenuBar>
        <MenuItems isOpen={mobileNavOpen}>
          {navLinks.map((link, i) => {
            if (link.type === 'link') {
              return <LinkWrapper href={link.url} text={link.text} key={i} />
            } else {
              return (
                <MobileDropdown text={link.text} links={link.links} key={i} />
              )
            }
          })}
        </MenuItems>
      </MobileNavWrapper>
    </>
  )
}

Nav.propTypes = {
  siteTitle: PropTypes.string,
}

Nav.defaultProps = {
  siteTitle: ``,
}

export default Nav
